export const composeEditorQueryKey = 'contentEditor'
export const composeUseTemplateQueryKey = 'useEmailTemplate'
